import {Component, OnInit} from '@angular/core';
import {BlogService} from './_services/blog.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

    constructor(private blogService: BlogService) {
    }

    blogPosts = [];

    // Pagination
    page = 1; // Page selected at start
    pageSize = 6; // How many post per page
    totalElements: number // Total blog posts

    // Sort
    sortName = 'postingDate';
    sortDirOrder = 'desc';

    ngOnInit() {
        this.listBlogPostFilter();
    }


    listBlogPostFilter() {
        this.blogService.listPublishedBlogPosts(this.pageSize, this.page, this.sortName, this.sortDirOrder, {}).subscribe((resp: any) => {
            this.blogPosts = resp.content;
            this.totalElements = resp.totalElements;
        })
    }

    onPageChange(page: number) {
        this.page = page;
        this.listBlogPostFilter();
    }

}
